import Svg, { Path } from 'react-native-svg';
import { IconProps } from './types';
import { colors } from '../constants';

export const IconCross = ({
  width = 18,
  height = 18,
  color = colors.gray2,
}: IconProps) => {
  return (
    <Svg width={width} height={height} viewBox="0 0 18 18" fill="none">
      <Path
        d="M9.00006 10.8667L2.46673 17.4001C2.22229 17.6445 1.91118 17.7667 1.5334 17.7667C1.15562 17.7667 0.84451 17.6445 0.600065 17.4001C0.355621 17.1556 0.233398 16.8445 0.233398 16.4667C0.233398 16.089 0.355621 15.7778 0.600065 15.5334L7.1334 9.00006L0.600065 2.46673C0.355621 2.22229 0.233398 1.91118 0.233398 1.5334C0.233398 1.15562 0.355621 0.84451 0.600065 0.600065C0.84451 0.355621 1.15562 0.233398 1.5334 0.233398C1.91118 0.233398 2.22229 0.355621 2.46673 0.600065L9.00006 7.1334L15.5334 0.600065C15.7778 0.355621 16.089 0.233398 16.4667 0.233398C16.8445 0.233398 17.1556 0.355621 17.4001 0.600065C17.6445 0.84451 17.7667 1.15562 17.7667 1.5334C17.7667 1.91118 17.6445 2.22229 17.4001 2.46673L10.8667 9.00006L17.4001 15.5334C17.6445 15.7778 17.7667 16.089 17.7667 16.4667C17.7667 16.8445 17.6445 17.1556 17.4001 17.4001C17.1556 17.6445 16.8445 17.7667 16.4667 17.7667C16.089 17.7667 15.7778 17.6445 15.5334 17.4001L9.00006 10.8667Z"
        fill={color}
      />
    </Svg>
  );
};
